/* enquiry-zero-fix v2 2026-07-23T23:12 */
(function(){
  'use strict';

  /* ============================================================
     Reveal-on-scroll fade (matches radio page).
     Note: JS adds .is-pre-reveal — so if JS fails, sections stay visible.
     ============================================================ */
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('.ooh-page section[data-section]').forEach(function(el){
      if (el.dataset.section === 'hero' || el.dataset.section === 'trust') {
        el.classList.add('is-revealed');
        return;
      }
      el.classList.add('is-pre-reveal');
    });
    var revealObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-revealed'); revealObs.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px 100px 0px' });
    document.querySelectorAll('.ooh-page section.is-pre-reveal').forEach(function(el){ revealObs.observe(el); });
  }

  /* ============================================================
     Page data
     ============================================================ */
  var data;
  try { data = JSON.parse(document.getElementById('ov1-data').textContent); }
  catch(e){ data = { currency:'AED', variants:[], weekly_impressions_raw: 0 }; }
  var variants = data.variants || [];
  var currency = data.currency || 'AED';

  function getSelectedOptions(){
    var opts = [];
    document.querySelectorAll('.ov1-form input[data-option-input]:checked').forEach(function(i){
      var pos = parseInt(i.getAttribute('data-option-position'), 10) || (opts.length + 1);
      opts[pos-1] = i.value;
    });
    return opts.filter(function(v){ return v != null; });
  }
  function findVariant(opts){
    if (!variants.length || !opts.length) return null;
    for (var i=0; i<variants.length; i++){
      var v = variants[i];
      if (!v.options || v.options.length !== opts.length) continue;
      var match = true;
      for (var j=0; j<opts.length; j++){
        if (String(v.options[j]).trim() !== String(opts[j]).trim()){ match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }
  function formatMoney(amount){
    return amount.toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
  }

  /* ============================================================
     Flight length and audience period, both counted in days.
     Total impressions = audience count x flight days / audience period days.
     A month is 365.25 / 12 days, so a monthly audience booked for "1 Month"
     returns exactly the owner's monthly figure and "4 Weeks" returns 28 days
     of it. Anything that cannot be read with confidence returns null and the
     totals are hidden rather than guessed.
     ============================================================ */
  var MONTH_DAYS = 365.25 / 12;
  var UNIT_RE = '(days?|weeks?|wks?|fortnights?|months?|mths?|years?|yrs?)';
  var NUM_WORD_RE = '(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)';
  var NUM_WORDS = { one:1, two:2, three:3, four:4, five:5, six:6, seven:7, eight:8, nine:9, ten:10, eleven:11, twelve:12 };
  var LENGTH_WORD_RE = /\b(days?|weeks?|wks?|fortnights?|months?|mths?|years?|yrs?|daily|weekly|fortnightly|monthly|yearly|annual|annually|hours?|hourly|hrs?)\b/i;

  function unitDays(u){
    u = String(u).toLowerCase();
    if (/^(day|daily)/.test(u)) return 1;
    if (/^fortnight/.test(u)) return 14;
    if (/^(week|wk)/.test(u)) return 7;
    if (/^(month|mth)/.test(u)) return MONTH_DAYS;
    if (/^(year|yr|annual)/.test(u)) return 365.25;
    if (/^hour/.test(u)) return 1 / 24;
    return null;
  }

  // Days covered by one unit of a variant title: "1 Month" 30.44, "2 Weeks" 14,
  // "Per Day" 1, "10 cars / 1 Month" 30.44, "1 month, 15 second slot" 30.44.
  // Hours, minutes and seconds describe spots and loops, never the flight, and
  // hourly pricing returns null because a site's operating hours are unknown.
  // A minimum-booking note is ignored, and a bare noun ("Month") counts only
  // when nothing more explicit is present, so "1 Week / Day plan" stays one
  // week. Ranges ("2 to 4 days", "6 or 12 months", "11+ days"), two different
  // lengths, or no length at all return null.
  function flightDays(title){
    var s = String(title || '').toLowerCase();
    if (!s || /\bper\s+hour\b|\bhourly\b/.test(s)) return null;
    s = s.replace(/\b(?:minimum|min)\.?\s+(?:of\s+)?\d+(?:\.\d+)?\s*-?\s*[a-z]+|\d+(?:\.\d+)?\s*-?\s*[a-z]+\s+(?:minimum|min)\b/g, ' ');
    var rangeRe = new RegExp('(\\d+(\\.\\d+)?|' + NUM_WORD_RE + ')\\s*(-|\\u2013|to|or|and)\\s*(\\d+(\\.\\d+)?|' + NUM_WORD_RE + ')\\s*-?\\s*' + UNIT_RE + '\\b');
    if (rangeRe.test(s) || new RegExp('\\d\\s*\\+\\s*' + UNIT_RE + '\\b').test(s)) return null;
    var found = [];
    var countRe = new RegExp('(\\d+(?:\\.\\d+)?|\\b' + NUM_WORD_RE + ')\\s*-?\\s*' + UNIT_RE + '\\b', 'g');
    s = s.replace(countRe, function(m, n, w, u){
      found.push((NUM_WORDS[n] || parseFloat(n)) * unitDays(u));
      return ' ';
    });
    s = s.replace(/\b(?:per|a|an|each|every)\s+(day|week|fortnight|month|year)\b|\b(daily|weekly|fortnightly|monthly|yearly|annual|annually)\b/g, function(m, u, adj){
      found.push(unitDays(u || adj));
      return ' ';
    });
    if (!found.length){
      s.replace(/\b(day|week|fortnight|month|year)\b/g, function(m, u){
        found.push(unitDays(u));
        return ' ';
      });
    }
    if (!found.length) return null;
    for (var i = 1; i < found.length; i++){
      if (Math.abs(found[i] - found[0]) > 1e-9) return null;
    }
    return found[0] > 0 ? found[0] : null;
  }

  // A variant title that names no length at all ("Face A", "Default Title")
  // takes the product's campaign duration instead.
  function variantDays(title){
    var d = flightDays(title);
    if (d == null && !LENGTH_WORD_RE.test(String(title || ''))) d = flightDays(data.duration);
    return d;
  }

  // Owner audience line to { count, days }: "11.56M monthly OMC impacts",
  // "441 422 monthly visual audience contacts", "14,217 gross contacts per
  // 14 days", "238,000 (34,000 daily average)". The period is read only from
  // the words after the figure and before any other number, so a bracketed
  // daily average cannot relabel a weekly total. A line with no period falls
  // back to defaultDays; a range or a percentage returns null.
  function parseAudience(line, defaultDays){
    var s = String(line || '').toLowerCase().replace(/[  ]/g, ' ');
    var m = s.match(/(\d{1,3}(?:[, ]\d{3})+(?!\d)|\d+)(?:([.,])(\d{1,2}(?!\d)|\d+(?=\s*[a-z]))|(\.\d+))?(?:\s*(bn|billion|mn|million|m|thousand|k)\b)?/);
    if (!m) return null;
    var count = parseFloat(m[1].replace(/[, ]/g, '') + (m[3] ? '.' + m[3] : '') + (m[4] || ''));
    count = count * ({ bn:1e9, billion:1e9, mn:1e6, million:1e6, m:1e6, thousand:1e3, k:1e3 }[m[5]] || 1);
    var tail = s.slice(m.index + m[0].length);
    if (/^\s*\+?\s*%/.test(tail)) return null;
    if (/^\s*\+?\s*(-|–|to|or|and)\s*\d/.test(tail)) return null;
    var periodRe = new RegExp('(?:\\b(?:per|a|an|each|every|in|over)\\s+|\\/\\s*)(\\d+(?:\\.\\d+)?\\s*-?\\s*)?(' + UNIT_RE.slice(1, -1) + '|hours?)\\b|\\b(daily|weekly|fortnightly|monthly|yearly|annual|annually|hourly)\\b');
    var p = tail.match(periodRe);
    var days = defaultDays;
    if (p && !/\d/.test(tail.slice(0, p.index))){
      days = p[3] ? unitDays(p[3]) : (p[1] ? parseFloat(p[1]) : 1) * unitDays(p[2]);
    }
    if (!(count > 0) || !(days > 0)) return null;
    return { count: count, days: days };
  }

  // Same precedence as the figure printed beside the totals: the numeric
  // weekly_impressions_raw, then weekly_impressions, then campaign_reach.
  function readAudience(d){
    var a = d.audience;
    if (!a) return null;
    var raw = parseFloat(a.weekly_impressions_raw);
    if (raw > 0) return { count: raw, days: 7 };
    if (a.weekly_impressions) return parseAudience(a.weekly_impressions, 7);
    if (a.campaign_reach) return parseAudience(a.campaign_reach, null);
    return null;
  }
  var audience = readAudience(data);

  /* ============================================================
     Buy widget — variant picker + qty + total + CPM
     ============================================================ */
  var totalEl = document.querySelector('[data-total]');
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  var addCta = document.querySelector('[data-add-cta]');
  var addCtaLabel = document.querySelector('[data-add-cta-label]');
  var variantIdInput = document.querySelector('[data-variant-id-input]');
  var summaryH = document.querySelector('[data-summary-h]');
  var summaryFlight = document.querySelector('[data-summary-flight]');
  var totalImpressionsEl = document.querySelector('[data-total-impressions]');
  var cpmEl = document.querySelector('[data-cpm]');
  var stickyEl = document.querySelector('[data-sticky]');
  var stickyVariant = document.querySelector('[data-sticky-variant]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAdd = document.querySelector('[data-sticky-add]');

  function update(){
    var opts = getSelectedOptions();
    var v = findVariant(opts);
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (qty < 1){ qty = 1; if (qtyInput) qtyInput.value = 1; }

    if (!v){
      if (totalEl) totalEl.innerHTML = '— <small>'+currency+'</small>';
      if (addCta){ addCta.disabled = true; addCta.classList.add('is-disabled'); }
      if (addCtaLabel) addCtaLabel.textContent = 'Unavailable';
      if (totalImpressionsEl) totalImpressionsEl.textContent = '—';
      if (cpmEl) cpmEl.textContent = '—';
      return;
    }
    var available = v.available !== false;
    var line = (v.price/100) * qty;
    if (totalEl) totalEl.innerHTML = (v.price === 0) ? 'Rates on enquiry' : (formatMoney(line) + ' <small>'+currency+'</small>');
    if (variantIdInput) variantIdInput.value = v.id;
    if (addCta){
      addCta.disabled = !available;
      addCta.classList.toggle('is-disabled', !available);
    }
    if (addCtaLabel) addCtaLabel.textContent = available ? 'Add to cart' : 'Unavailable';
    if (summaryH) {
      var origText = summaryH.textContent;
      var pivot = origText.indexOf('·');
      if (pivot > 0) {
        summaryH.textContent = v.title + ' ' + origText.slice(pivot - 1);
      } else {
        summaryH.textContent = v.title;
      }
    }
    if (summaryFlight) summaryFlight.textContent = v.title;

    if (totalImpressionsEl && cpmEl) {
      var days = variantDays(v.title);
      var totalImps = (audience && days) ? Math.round(audience.count * days / audience.days * qty) : 0;
      var showTotals = totalImps > 0 && v.price > 0;
      [totalImpressionsEl, cpmEl].forEach(function(el){
        var cell = el.closest('.book-summary-total');
        if (cell) cell.style.display = showTotals ? '' : 'none';
      });
      if (showTotals) {
        var cpm = (line / totalImps) * 1000;
        totalImpressionsEl.textContent = totalImps.toLocaleString();
        cpmEl.textContent = currency + ' ' + (cpm < 10 ? cpm.toFixed(2) : Math.round(cpm).toLocaleString());
      }
    }

    if (stickyVariant) stickyVariant.textContent = (opts.join(' / ') || '');
    if (stickyPrice) stickyPrice.textContent = (v.price === 0) ? 'On enquiry' : (formatMoney(line) + ' ' + currency);
  }

  /* Segmented selector — sync radio + .is-on visual class */
  document.querySelectorAll('.ov1-form input[data-option-input]').forEach(function(i){
    i.addEventListener('change', function(){
      // toggle is-on on parent label siblings within same group
      var group = i.closest('.book-segmented');
      if (group) {
        group.querySelectorAll('.book-seg').forEach(function(seg){ seg.classList.remove('is-on'); });
        i.closest('.book-seg').classList.add('is-on');
      }
      update();
    });
  });
  /* Make whole label clickable as button (the radio is hidden) */
  document.querySelectorAll('.ov1-form .book-seg').forEach(function(seg){
    seg.addEventListener('click', function(e){
      var input = seg.querySelector('input[type=radio]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  if (qtyInput) qtyInput.addEventListener('input', update);
  if (qtyMinus) qtyMinus.addEventListener('click', function(){
    if (!qtyInput) return;
    var v = parseInt(qtyInput.value, 10) || 1;
    if (v > 1){ qtyInput.value = v - 1; update(); }
  });
  if (qtyPlus) qtyPlus.addEventListener('click', function(){
    if (!qtyInput) return;
    var v = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = v + 1; update();
  });
  if (stickyAdd) stickyAdd.addEventListener('click', function(){
    var form = document.getElementById('ov1-product-form');
    if (form) form.submit();
  });

  /* Scroll-to-buy from hero CTA */
  document.querySelectorAll('[data-scroll-buy]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var t = document.getElementById('buy');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Scroll-to-brief from enquiry CTAs */
  document.querySelectorAll('[data-scroll-brief]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var t = document.getElementById('brief');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  update();

  /* ============================================================
     Sticky bar — show after scrolling past buy widget
     ============================================================ */
  var buyEl = document.getElementById('buy');
  if (stickyEl && buyEl){
    var stickyObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.intersectionRatio > 0.05){
          stickyEl.hidden = true;
        } else if (e.boundingClientRect.top < 0){
          stickyEl.hidden = false;
        }
      });
    }, { threshold: [0, 0.05, 0.5] });
    stickyObs.observe(buyEl);
  }

  /* ============================================================
     FAQ accordion (faq-v3 — only one open at a time)
     ============================================================ */
  document.querySelectorAll('.faq-v3-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-v3-item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      // close all
      document.querySelectorAll('.faq-v3-item.is-open').forEach(function(o){ o.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  /* ============================================================
     Share menu
     ============================================================ */
  var shareWrap = document.querySelector('[data-share-wrap]');
  var shareTrigger = shareWrap ? shareWrap.querySelector('[data-share-trigger]') : null;
  var shareMenu = shareWrap ? shareWrap.querySelector('[data-share-menu]') : null;
  if (shareTrigger && shareMenu){
    shareTrigger.addEventListener('click', function(e){
      e.stopPropagation();
      var open = !shareMenu.hidden;
      shareMenu.hidden = open;
    });
    document.addEventListener('click', function(){ shareMenu.hidden = true; });
    shareMenu.addEventListener('click', function(e){ e.stopPropagation(); });

    var pageUrl = location.href;
    var pageTitle = document.title;
    shareMenu.querySelectorAll('[data-share-action]').forEach(function(el){
      var action = el.getAttribute('data-share-action');
      if (action === 'email'){
        el.href = 'mailto:?subject=' + encodeURIComponent(pageTitle) + '&body=' + encodeURIComponent(pageUrl);
      } else if (action === 'whatsapp'){
        el.href = 'https://wa.me/?text=' + encodeURIComponent(pageTitle + ' ' + pageUrl);
      } else if (action === 'linkedin'){
        el.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(pageUrl);
      } else if (action === 'copy'){
        el.addEventListener('click', function(){
          if (navigator.clipboard){
            navigator.clipboard.writeText(pageUrl).then(function(){
              var lbl = el.querySelector('[data-share-copy-label]');
              if (lbl){ var prev = lbl.textContent; lbl.textContent = 'Copied!'; setTimeout(function(){ lbl.textContent = prev; }, 1400); }
            });
          }
        });
      }
    });
  }

  /* ============================================================
     Gallery + Lightbox
     ============================================================ */
  var galleryImages = [];
  try { galleryImages = JSON.parse(document.getElementById('ov1-images').textContent); }
  catch(e) { galleryImages = []; }

  var lb = document.querySelector('[data-lb]');
  var lbImg = lb ? lb.querySelector('[data-lb-img]') : null;
  var lbCounter = lb ? lb.querySelector('[data-lb-counter]') : null;
  var lbClose = lb ? lb.querySelector('[data-lb-close]') : null;
  var lbPrev = lb ? lb.querySelector('[data-lb-prev]') : null;
  var lbNext = lb ? lb.querySelector('[data-lb-next]') : null;
  var lbIdx = 0;

  function openLb(i){
    if (!lb || !galleryImages.length) return;
    lbIdx = ((i % galleryImages.length) + galleryImages.length) % galleryImages.length;
    if (lbImg){ lbImg.src = galleryImages[lbIdx].src; lbImg.alt = galleryImages[lbIdx].alt || ''; }
    if (lbCounter) lbCounter.textContent = (lbIdx + 1) + ' / ' + galleryImages.length;
    lb.hidden = false;
    requestAnimationFrame(function(){ lb.classList.add('is-on'); });
    document.body.style.overflow = 'hidden';
  }
  function closeLb(){
    if (!lb) return;
    lb.classList.remove('is-on');
    setTimeout(function(){ lb.hidden = true; }, 220);
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-gallery-main], [data-gallery-thumb], [data-gallery-more]').forEach(function(el){
    el.addEventListener('click', function(){
      var i = parseInt(el.getAttribute('data-index'), 10) || 0;
      openLb(i);
    });
  });
  if (lbClose) lbClose.addEventListener('click', closeLb);
  if (lbPrev) lbPrev.addEventListener('click', function(e){ e.stopPropagation(); openLb(lbIdx - 1); });
  if (lbNext) lbNext.addEventListener('click', function(e){ e.stopPropagation(); openLb(lbIdx + 1); });
  if (lb) lb.addEventListener('click', function(e){ if (e.target === lb) closeLb(); });
  document.addEventListener('keydown', function(e){
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') closeLb();
    else if (e.key === 'ArrowLeft') openLb(lbIdx - 1);
    else if (e.key === 'ArrowRight') openLb(lbIdx + 1);
  });

  /* ============================================================
     Save drawer (shared with radio — same localStorage key)
     ============================================================ */
  var SAVE_KEY = 'media_co_uk_saved';
  function readSaved(){
    try { return JSON.parse(localStorage.getItem(SAVE_KEY) || '[]'); }
    catch(e){ return []; }
  }
  function writeSaved(list){
    try { localStorage.setItem(SAVE_KEY, JSON.stringify(list)); } catch(e){}
  }
  var savePill = document.querySelector('[data-save-pill]');
  var saveCount = document.querySelector('[data-save-count]');
  var saveCountHeader = document.querySelector('[data-save-count-header]');
  var saveDrawer = document.querySelector('[data-save-drawer]');
  var saveList = document.querySelector('[data-save-list]');
  var saveEmpty = document.querySelector('[data-save-empty]');
  var saveFooter = document.querySelector('[data-save-footer]');
  var saveTrigger = document.querySelector('[data-save-trigger]');
  var saveLabel = document.querySelector('[data-save-label]');

  function isSaved(handle){ return readSaved().some(function(x){ return x.handle === handle; }); }
  function refreshSaveUI(){
    var list = readSaved();
    if (saveCount) saveCount.textContent = list.length;
    if (saveCountHeader) saveCountHeader.textContent = '(' + list.length + ')';
    if (savePill) savePill.hidden = list.length === 0;
    if (saveTrigger){
      var handle = saveTrigger.getAttribute('data-handle');
      var on = isSaved(handle);
      saveTrigger.classList.toggle('is-on', on);
      if (saveLabel) saveLabel.textContent = on ? '♥ Saved' : '♡ Save';
    }
    if (saveList){
      saveList.querySelectorAll('.ov1-save-card').forEach(function(n){ n.remove(); });
      if (list.length === 0){
        if (saveEmpty) saveEmpty.style.display = '';
        if (saveFooter) saveFooter.hidden = true;
      } else {
        if (saveEmpty) saveEmpty.style.display = 'none';
        if (saveFooter) saveFooter.hidden = false;
        list.forEach(function(item){
          var a = document.createElement('a');
          a.className = 'ov1-save-card';
          a.href = item.url;
          a.innerHTML = (item.logo ? '<img src="'+item.logo+'" alt="" loading="lazy">' : '<span class="ov1-save-letter">'+(item.title||'?').slice(0,1)+'</span>')
            + '<div class="ov1-save-info"><div class="ov1-save-name">'+item.title+'</div><div class="ov1-save-meta">'+(item.country||'')+(item.listeners?' · '+item.listeners:'')+'</div></div>'
            + '<button type="button" class="ov1-save-remove" data-save-remove="'+item.handle+'" aria-label="Remove">×</button>';
          saveList.appendChild(a);
        });
        saveList.querySelectorAll('[data-save-remove]').forEach(function(btn){
          btn.addEventListener('click', function(e){
            e.preventDefault(); e.stopPropagation();
            var h = btn.getAttribute('data-save-remove');
            writeSaved(readSaved().filter(function(x){ return x.handle !== h; }));
            refreshSaveUI();
          });
        });
      }
    }
  }
  if (saveTrigger){
    saveTrigger.addEventListener('click', function(){
      var handle = saveTrigger.getAttribute('data-handle');
      var list = readSaved();
      if (isSaved(handle)){
        list = list.filter(function(x){ return x.handle !== handle; });
      } else {
        list.push({
          handle: handle,
          title: saveTrigger.getAttribute('data-title'),
          url: saveTrigger.getAttribute('data-url'),
          logo: saveTrigger.getAttribute('data-logo'),
          country: saveTrigger.getAttribute('data-country'),
          listeners: saveTrigger.getAttribute('data-listeners'),
          format: saveTrigger.getAttribute('data-format')
        });
      }
      writeSaved(list);
      refreshSaveUI();
    });
  }
  function openSaveDrawer(){
    if (!saveDrawer) return;
    saveDrawer.hidden = false;
    requestAnimationFrame(function(){ saveDrawer.setAttribute('data-open', 'true'); });
  }
  function closeSaveDrawer(){
    if (!saveDrawer) return;
    saveDrawer.setAttribute('data-open', 'false');
    setTimeout(function(){ saveDrawer.hidden = true; }, 300);
  }
  if (savePill){
    savePill.addEventListener('click', openSaveDrawer);
  }
  document.querySelectorAll('[data-save-close]').forEach(function(el){
    el.addEventListener('click', closeSaveDrawer);
  });
  var saveClear = document.querySelector('[data-save-clear]');
  if (saveClear) saveClear.addEventListener('click', function(){
    writeSaved([]); refreshSaveUI();
  });
  var saveShare = document.querySelector('[data-save-share]');
  if (saveShare) saveShare.addEventListener('click', function(){
    var list = readSaved();
    var text = 'My saved Media.co.uk placements:\n\n' + list.map(function(x){ return '- ' + x.title + ' (' + x.url + ')'; }).join('\n');
    if (navigator.clipboard){
      navigator.clipboard.writeText(text).then(function(){
        var lbl = document.querySelector('[data-save-share-label]');
        if (lbl){ var prev = lbl.textContent; lbl.textContent = 'Copied!'; setTimeout(function(){ lbl.textContent = prev; }, 1400); }
      });
    }
  });
  refreshSaveUI();
})();
